import React, { useState, useEffect } from 'react';
import { useData } from '../DataContext';
import { useLang } from '../LanguageContext'; 
import { FileText, Printer, X, Search, PieChart, ChevronLeft, ChevronRight } from 'lucide-react';

// --- [게임 관리와 동일한 정산서 모달 컴포넌트] ---
const SettlementDetailModal = ({ game, agent, onClose }) => {
  const { t } = useLang(); 
  if (!game) return null;

  const fmt = (num) => num ? Math.floor(Number(num)).toLocaleString() : '0';

  const calculateSheet = (g) => {
    const totalChipsBuy = parseFloat(g.sumBuyIn || 0);
    const totalCashOut = parseFloat(g.sumCashOut || 0);
    const gameWinLoss = totalChipsBuy - totalCashOut;
    
    const rollingAmount = parseFloat(g.totalRolling || 0);
    const commRate = parseFloat(g.rollingComm || 0);
    const rollingComm = Math.floor(rollingAmount * (commRate / 100));
    
    let netWinLoss = 0;
    let shareProfit = 0;

    if (g.type === 'Share') {
      netWinLoss = gameWinLoss - rollingComm;
      const shareRate = parseFloat(g.shareRate || 0);
      shareProfit = Math.floor(netWinLoss * (shareRate / 100));
    }
    return { totalChipsBuy, totalCashOut, gameWinLoss, rollingAmount, rollingComm, netWinLoss, shareProfit };
  };

  const calc = calculateSheet(game);

  const handlePrint = () => {
    window.print();
  };

  return (
    <div id="print-overlay" style={{ 
      position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', 
      backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1200 
    }}>
      <div id="print-sheet" style={{ 
        backgroundColor: 'white', 
        width: '800px',        
        maxHeight: '90vh',     
        padding: '40px',       
        borderRadius: '8px', 
        boxShadow: '0 20px 50px rgba(0,0,0,0.3)', 
        position:'relative',
        overflowY: 'auto'      
      }}>
        {/* 헤더 */}
        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'30px', borderBottom:'2px solid #0f172a', paddingBottom:'20px' }}>
          <div style={{ width:'120px', height:'60px', backgroundColor:'#e2e8f0', display:'flex', alignItems:'center', justifyContent:'center', fontWeight:'bold', color:'#64748b' }}>
            {t('lbl_comp_logo') || 'LOGO'}
          </div>
          <div style={{ textAlign:'right' }}>
            <h1 style={{ margin:0, fontSize:'28px', color:'#0f172a', letterSpacing:'1px', textTransform:'uppercase' }}>{t('menu_reports')}</h1>
            <p style={{ margin:'5px 0', fontSize:'16px', fontWeight:'bold', color:'#2563eb' }}>
              GAME: {game.id} &nbsp;|&nbsp; AGENT: {game.agentId}
            </p>
            <p style={{ margin:0, color:'#64748b', fontSize:'14px' }}>{t('date')}: {new Date().toLocaleDateString()}</p>
            <p style={{ margin:0, color:'#64748b', fontSize:'14px' }}>{t('staff')}: {game.settledBy || '-'}</p>
          </div>
        </div>

        {/* 정산 내용 */}
        <div style={{ marginBottom:'40px', border:'1px solid #e2e8f0', borderRadius:'8px', padding:'20px' }}>
            <div style={{ display:'flex', justifyContent:'space-between', marginBottom:'10px', fontSize:'15px' }}>
              <span>{t('totalBuyIn')}</span>
              <span style={{ fontWeight:'bold' }}>{fmt(calc.totalChipsBuy)}</span>
            </div>
            <div style={{ display:'flex', justifyContent:'space-between', marginBottom:'10px', fontSize:'15px' }}>
              <span>{t('totalCashOut')}</span>
              <span style={{ fontWeight:'bold' }}>{fmt(calc.totalCashOut)}</span>
            </div>
            
            <div style={{ display:'flex', justifyContent:'space-between', padding:'12px 15px', borderTop:'1px solid #cbd5e1', borderBottom:'1px solid #cbd5e1', marginBottom:'20px', background:'#f8fafc', borderRadius:'4px' }}>
              <span style={{ fontWeight:'bold', color:'#334155' }}>{t('gameWinLoss')}</span>
              <span style={{ fontWeight:'bold', fontSize:'16px', color: calc.gameWinLoss < 0 ? '#dc2626' : '#0f172a' }}>
                {fmt(calc.gameWinLoss)}
              </span>
            </div>

            <div style={{ display:'flex', justifyContent:'space-between', marginBottom:'10px', fontSize:'15px' }}>
              <span>{t('totalRolling')}</span>
              <span>{fmt(calc.rollingAmount)}</span>
            </div>
            <div style={{ display:'flex', justifyContent:'space-between', marginBottom:'10px', fontSize:'15px' }}>
              <span>Commission %</span>
              <span>{game.rollingComm}%</span>
            </div>
            <div style={{ display:'flex', justifyContent:'space-between', marginBottom:'20px', fontWeight:'bold', color:'#059669', fontSize:'15px' }}>
              <span>{t('rollingComm')}</span>
              <span>{fmt(calc.rollingComm)}</span>
            </div>

            {game.type === 'Share' && (
              <>
                <div style={{ borderTop:'2px dashed #cbd5e1', margin:'20px 0' }}></div>
                <div style={{ display:'flex', justifyContent:'space-between', marginBottom:'10px', fontSize:'15px' }}>
                  <span>{t('netWinLoss')} <span style={{fontSize:'11px', color:'#94a3b8'}}>(Win/Loss - Comm)</span></span>
                  <span style={{ fontWeight:'bold' }}>{fmt(calc.netWinLoss)}</span>
                </div>
                <div style={{ display:'flex', justifyContent:'space-between', marginBottom:'10px', fontSize:'15px' }}>
                  <span>Share %</span>
                  <span>{game.shareRate}%</span>
                </div>
                <div style={{ display:'flex', justifyContent:'space-between', padding:'15px', background:'#ecfdf5', borderRadius:'6px', border:'1px solid #10b981', marginTop:'10px' }}>
                  <span style={{ fontWeight:'bold', color:'#047857' }}>{t('shareProfit')}</span>
                  <span style={{ fontWeight:'bold', fontSize:'18px', color:'#047857' }}>{fmt(calc.shareProfit)}</span>
                </div>
              </>
            )}
        </div>

        {/* 서명란 */}
        <div style={{ display:'flex', justifyContent:'space-between', marginTop:'60px', paddingBottom: '20px' }}>
          <div style={{ textAlign:'center', width:'40%' }}>
            <div style={{ borderBottom:'1px solid #334155', height:'40px', marginBottom:'10px' }}></div>
            <span style={{ fontWeight:'bold', fontSize:'14px' }}>{t('menu_cage')}</span>
          </div>
          <div style={{ textAlign:'center', width:'40%' }}>
            <div style={{ borderBottom:'1px solid #334155', height:'40px', marginBottom:'10px', display:'flex', alignItems:'flex-end', justifyContent:'center' }}>
                {agent ? `${agent.engSurname} ${agent.engGivenName}` : ''}
            </div>
            <span style={{ fontWeight:'bold', fontSize:'14px' }}>{t('menu_agents')}</span>
          </div>
        </div>

        {/* 버튼들 */}
        <div className="no-print" style={{ position:'absolute', top:'20px', right:'20px', display:'flex', gap:'10px' }}>
          <button onClick={handlePrint} style={{ display:'flex', alignItems:'center', gap:'5px', padding:'10px 15px', background:'#dc2626', color:'white', border:'none', borderRadius:'6px', fontWeight:'bold', cursor:'pointer' }}>
            <Printer size={16}/> {t('pdf')}
          </button>
          <button onClick={onClose} style={{ display:'flex', alignItems:'center', gap:'5px', padding:'10px 15px', background:'#64748b', color:'white', border:'none', borderRadius:'6px', fontWeight:'bold', cursor:'pointer' }}>
            <X size={16}/> {t('close')}
          </button>
        </div>
      </div>
    </div>
  );
};


// --- [메인 정산서 페이지] ---
const Reports = () => {
  const { games, agents } = useData();
  const { t } = useLang(); 
  
  const [tempFromDate, setTempFromDate] = useState('');
  const [tempToDate, setTempToDate] = useState('');
  const [appliedFromDate, setAppliedFromDate] = useState('');
  const [appliedToDate, setAppliedToDate] = useState('');

  // ★ [추가] 페이지네이션 상태
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 20;

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedSettlement, setSelectedSettlement] = useState(null);

  const handleDateSearch = () => {
    // 날짜 검색 시 1페이지로 리셋
    setCurrentPage(1); 
    if (!tempFromDate && !tempToDate) {
      setAppliedFromDate(''); setAppliedToDate('');
      return;
    }
    setAppliedFromDate(tempFromDate);
    setAppliedToDate(tempToDate);
  };

  const handleOpenModal = (settlement) => {
    setSelectedSettlement(settlement);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedSettlement(null);
  };

  const fmt = (num) => num ? Number(num).toLocaleString() : '0';

  const totalRolling = games.reduce((sum, g) => sum + (parseFloat(g.totalRolling) || 0), 0);
  const totalBuyIn = games.reduce((sum, g) => sum + (parseFloat(g.sumBuyIn) || 0), 0);
  
  // ★ [권한 제한 없음] 모든 정산 내역 필터링
  const settledGames = games.filter(g => {
      const isSettled = g.status === 'Settled';
      const gameDate = g.endDate || g.startedAt;
      const isDateInRange = (!appliedFromDate || gameDate >= appliedFromDate) && 
                            (!appliedToDate || gameDate <= appliedToDate);
      return isSettled && isDateInRange;
  }).sort((a, b) => new Date(b.endDate || b.startedAt) - new Date(a.endDate || a.startedAt));

  // ★ [추가] 페이지네이션 데이터 슬라이싱
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentSettledGames = settledGames.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(settledGames.length / itemsPerPage);

  const handlePageChange = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
        setCurrentPage(pageNumber);
    }
  };

  return (
    <div style={{ padding: '30px', color: '#1e293b' }}>
      <div className="no-print" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
        <div>
          <h2 style={{ fontSize: '24px', fontWeight: 'bold', margin: 0, color: '#0f172a' }}>📊 {t('report_title')}</h2>
          <p style={{ color: '#64748b', marginTop: '5px' }}>{t('report_sub')}</p>
        </div>
      </div>

      <div className="no-print" style={{ marginBottom: '30px', display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '8px' }}>
        <div style={{ display:'flex', alignItems:'center', gap:'5px', border:'1px solid #cbd5e1', borderRadius:'6px', padding:'5px 10px', background:'white' }}>
          <span style={{ fontSize:'13px', color:'#64748b', fontWeight:'bold' }}>From</span>
          <input type="date" value={tempFromDate} onChange={(e) => setTempFromDate(e.target.value)} style={{ border:'none', fontSize:'13px', outline:'none', color:'#334155' }} />
        </div>
        <span style={{color:'#94a3b8'}}>-</span>
        <div style={{ display:'flex', alignItems:'center', gap:'5px', border:'1px solid #cbd5e1', borderRadius:'6px', padding:'5px 10px', background:'white' }}>
          <span style={{ fontSize:'13px', color:'#64748b', fontWeight:'bold' }}>To</span>
          <input type="date" value={tempToDate} onChange={(e) => setTempToDate(e.target.value)} style={{ border:'none', fontSize:'13px', outline:'none', color:'#334155' }} />
        </div>
        <button onClick={handleDateSearch} style={{ padding:'6px 15px', backgroundColor:'#0284c7', color:'white', border:'none', borderRadius:'6px', cursor:'pointer', fontWeight:'bold', fontSize:'13px' }}>{t('search')}</button>
      </div>

      {/* 요약 카드 */}
      <div className="no-print" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '20px', marginBottom: '30px' }}>
        <div style={{ background: 'white', padding: '25px', borderRadius: '12px', border: '1px solid #e2e8f0', boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)' }}>
          <div style={{ color: '#64748b', fontSize: '14px', marginBottom: '10px' }}>{t('total_agents')}</div>
          <div style={{ fontSize: '28px', fontWeight: 'bold', color: '#0f172a' }}>{agents.length}</div>
        </div>
        <div style={{ background: 'white', padding: '25px', borderRadius: '12px', border: '1px solid #e2e8f0', boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)' }}>
          <div style={{ color: '#64748b', fontSize: '14px', marginBottom: '10px' }}>{t('total_active_games')}</div>
          <div style={{ fontSize: '28px', fontWeight: 'bold', color: '#2563eb' }}>{games.filter(g => g.status === 'Active').length}</div>
        </div>
        <div style={{ background: 'white', padding: '25px', borderRadius: '12px', border: '1px solid #e2e8f0', boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)' }}>
          <div style={{ color: '#64748b', fontSize: '14px', marginBottom: '10px' }}>{t('total_buyin')}</div>
          <div style={{ fontSize: '28px', fontWeight: 'bold', color: '#059669' }}>{fmt(totalBuyIn)}</div>
        </div>
        <div style={{ background: 'white', padding: '25px', borderRadius: '12px', border: '1px solid #e2e8f0', boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)' }}>
          <div style={{ color: '#64748b', fontSize: '14px', marginBottom: '10px' }}>{t('total_rolling_vol')}</div>
          <div style={{ fontSize: '28px', fontWeight: 'bold', color: '#d97706' }}>{fmt(totalRolling)}</div>
        </div>
      </div>

      {/* 정산 완료 내역 테이블 */}
      <div className="no-print" style={{ backgroundColor: 'white', borderRadius: '12px', border: '1px solid #e2e8f0', overflow: 'hidden' }}>
          <div style={{ padding: '20px', borderBottom: '1px solid #e2e8f0', fontWeight: 'bold', color: '#334155' }}>
              📋 {t('settled_list')}
          </div>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '14px', textAlign: 'center' }}>
              <thead style={{ backgroundColor: '#f8fafc' }}>
                  <tr>
                      <th style={{ padding: '15px' }}>{t('date')} ({t('settled')})</th>
                      <th>Game ID</th>
                      <th>{t('menu_agents')}</th>
                      <th>{t('totalBuyIn')}</th>
                      <th>{t('totalCashOut')}</th>
                      <th>{t('totalRolling')}</th>
                      <th>{t('action')}</th>
                  </tr>
              </thead>
              <tbody>
                  {/* ★ [수정] currentSettledGames (페이지네이션 적용된 데이터) 사용 */}
                  {currentSettledGames.length > 0 ? currentSettledGames.map(game => (
                      <tr key={game.id} style={{ borderBottom: '1px solid #f1f5f9' }}>
                          <td style={{ padding: '15px', color: '#64748b' }}>
                              {game.endDate ? new Date(game.endDate).toLocaleDateString() : '-'}
                          </td>
                          <td style={{ fontWeight: 'bold', color: '#2563eb' }}>{game.id}</td>
                          <td>{game.agentId}</td>
                          <td style={{ fontWeight: 'bold' }}>{fmt(game.sumBuyIn)}</td>
                          <td style={{ color: '#dc2626' }}>{fmt(game.sumCashOut)}</td>
                          <td style={{ color: '#d97706' }}>{fmt(game.totalRolling)}</td>
                          <td>
                              <button 
                                onClick={() => handleOpenModal(game)}
                                style={{ padding:'6px 12px', borderRadius:'6px', background:'#3b82f6', color:'white', border:'none', fontSize:'12px', fontWeight:'bold', cursor:'pointer', transition:'background 0.2s' }}
                                onMouseOver={(e) => e.currentTarget.style.background = '#2563eb'}
                                onMouseOut={(e) => e.currentTarget.style.background = '#3b82f6'}
                              >
                                  {t('view')}
                              </button>
                          </td>
                      </tr>
                  )) : (
                      <tr>
                          <td colSpan="7" style={{ padding: '30px', color: '#94a3b8' }}>No settled games found.</td>
                      </tr>
                  )}
              </tbody>
          </table>
      </div>

      {/* ★ [추가] 페이지네이션 컨트롤 */}
      {totalPages > 1 && (
        <div className="no-print" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '10px', marginTop: '20px' }}>
            <button 
                onClick={() => handlePageChange(currentPage - 1)} 
                disabled={currentPage === 1}
                style={{ padding: '8px', borderRadius: '50%', border: '1px solid #cbd5e1', background: 'white', cursor: currentPage === 1 ? 'not-allowed' : 'pointer', opacity: currentPage === 1 ? 0.5 : 1 }}
            >
                <ChevronLeft size={20} />
            </button>
            <span style={{ fontSize: '14px', fontWeight: 'bold', color: '#334155' }}>
                Page {currentPage} of {totalPages}
            </span>
            <button 
                onClick={() => handlePageChange(currentPage + 1)} 
                disabled={currentPage === totalPages}
                style={{ padding: '8px', borderRadius: '50%', border: '1px solid #cbd5e1', background: 'white', cursor: currentPage === totalPages ? 'not-allowed' : 'pointer', opacity: currentPage === totalPages ? 0.5 : 1 }}
            >
                <ChevronRight size={20} />
            </button>
        </div>
      )}

      {isModalOpen && selectedSettlement && (
        <SettlementDetailModal 
            game={selectedSettlement} 
            agent={agents.find(a => a.code === selectedSettlement.agentId)}
            onClose={handleCloseModal} 
        />
      )}

      <style>{`
        @media print {
            @page { size: auto; margin: 0; }
            html, body { height: 1px !important; overflow: hidden !important; background: white !important; margin: 0 !important; padding: 0 !important; }
            body * { visibility: hidden; }
            #print-overlay, #print-overlay * { visibility: visible; }
            #print-overlay { position: absolute !important; top: 0 !important; left: 0 !important; width: 100vw !important; height: 100vh !important; margin: 0 !important; padding: 20px !important; background: white !important; z-index: 99999 !important; }
            .no-print { display: none !important; }
        }
      `}</style>
    </div>
  );
};

export default Reports;